import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';
//  import * as moment from 'moment';
// import { REGCONSTANTS } from 'src/app/core/Constants/regex-constants';

export class CustomValidation {
  /*
desc   : for Email Validation
*/
  public static formNotNull(group: FormGroup | AbstractControl) {
    let valError = { atleastOneRequired: true }
    for (let val of Object.values(group.value)) {
      if (val) {
        return null;
      }
    }
    return valError;
  }
  public static email(control: AbstractControl) {
    if (control.value) {
      const email = control.value; // to get value in input tag
      const pattern = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,10}))$/
      );
      if (email && !pattern.test(email)) {
        return { email: true };
      }
      return null;
    } else {
      return null;
    }
  }
  public static PasswordRule(control: AbstractControl) {
    
    if (control.value) {
      const password = control.value; // to get value in input tag
      const pattern = new RegExp(
        '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,64}'
      );
      
      if (password && !pattern.test(password)) {
        return { PasswordRule: true };
      }
      return null;
    } else {
      return null;
    }
  }
  /**
   * 
   check the input contains only alphanumeric value with space
   */
  public static alphaNumericWithSpace(control: AbstractControl) {
    if (control.value) {
      const alphaNumericspace = control.value; // to get value in input tag
      const pattern = new RegExp(/^(?!\s)[a-zA-Z0-9_\s-]*$/);
      if (!pattern.test(alphaNumericspace)) {
        return { alphaNumericWithSpace: true };
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
  public static noSpaceOnly(control: AbstractControl): ValidationErrors | null {
    if (control.value && control.value.trim() === '') {
      return { noSpaceOnly: true };
    } else {
      return null;
    }
  }
  public static validUrl(control: AbstractControl) {
    if (control.value) {
      const validUrl = control.value;
      const pattern = new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');
      if (!pattern.test(validUrl)) {
        return { validUrl: true };
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
  public static onlyNumber(control: AbstractControl) {
    if (control.value) {
      const onlyNumber = control.value; // to get value in input tag
      const pattern = new RegExp(/^[0-9]*$/);
      if (!pattern.test(onlyNumber)) {
        return { onlyNumber: true };
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
   /**
   * 
   check the entered date has correct format
   */
  public static validityPattern(control: AbstractControl) {
    if (control.value) {
      let validity = control.value;
      let valStart = validity?.substring(0, validity.indexOf(' '));
      let parts: any[] = validity?.split(' ');
      let valEnd = parts?.pop();

      const pattern = new RegExp((/^\d{2}\/\d{2}\/\d{4}$/));
     
      if ((!pattern.test(valStart) || !pattern.test(valEnd))) {
        return { validityPattern: true };
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
  public static patternCheck(control: AbstractControl) {
    if (control.value) {
      let validity = control.value;
    
      const pattern = new RegExp((/^\d{2}\/\d{2}\/\d{4}$/));
     
      if ((!pattern.test(validity))) {
        return { patternCheck: true };
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
  /**
   * 
   check the entered end date lesser than current date
   */
  public static checkEndDate(control: AbstractControl) {
    if (control.value) {
      let validity = control.value;
      let parts: any[] = validity?.split(' ');
      let valEnd = parts?.pop();
      let validityEnd = valEnd?.split("/").reverse().join("-");
      let today = new Date().getTime();
      let date = validityEnd ? new Date(validityEnd).getTime() : null;
      if (date && date < today) {
        return { checkEndDate: true };
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
  /**
   * 
   check the entered start date lesser than current date
   */
  public static checkStartDateWithCurrentDate(control: AbstractControl) {
    if (control.value) {
      let validity = control.value;
      let valStart = validity?.substring(0, validity.indexOf(' '));
      let validityStart = valStart?.split("/").reverse().join("-"); 
      let today = new Date().getTime();
      let date = valStart ? (new Date(validityStart).getTime()) : null;
      if (date && date < today) {
        return { checkStartDateWithCurrentDate: true };
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
  
  public static checkDateWithToday(control: AbstractControl) {
    if (control.value) {
      let validity = control.value;  
      let validityStart = validity?.split("/").reverse().join("-"); 
      let today = new Date();
      let date = validityStart ? (new Date(validityStart)) : null; 
      let month = '' + (today.getMonth() + 1);
      let day = '' + today.getDate();
      let year = today.getFullYear();
      if (month.length < 2) {
        month = '0' + month;
      }
      if (day.length < 2) {
      day = '0' + day;
      }
      let formattedDate = [year, month, day].join('-');
      if (validityStart && validityStart < formattedDate) {
        return { checkDateWithToday: true };
      } else {
        return null;
      }
      } else {
      return null;
    }
  }
  /**
   * 
   comparing start and end date , start date must be less than enddate
   */
  public static checkStartDate(control: AbstractControl) {
    
    if (control.value) {
      let validity = control.value;
      let valStart = validity?.substring(0, validity.indexOf(' '));
      let parts: any[] = validity?.split(' ');
      let valEnd = parts?.pop();
      let validityStart = valStart?.split("/").reverse().join("-");
      let start = validityStart ? (new Date(validityStart).getTime()) : null;
      let validityEnd = valEnd?.split("/").reverse().join("-");
      let end = validityEnd ? (new Date(validityEnd).getTime()) : null;
      if ( ((start && end) && (start > end))) {
        return { checkStartDate: true };
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
  public static allowAlphanumericWithspace(control: AbstractControl) {
    if (control.value) {
      const alphaNumericspace = control.value; // to get value in input tag
      const pattern = new RegExp(/^(?!\s)[a-zA-Z0-9_\s-]*$/);
      if (!pattern.test(alphaNumericspace)) {
        return { alphaNumericspace: true };
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
  public static noWhitespaceValidator(control: AbstractControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
}
public static noSpaceAtStart (control:AbstractControl) {
 if(control.value){
   const noSpaceAtStart = control.value;   
   const pattern = new RegExp(/^\w.*$/);
 if (!pattern.test(noSpaceAtStart)) {
  return { noSpaceAtStart: true };
} else {
  return null;
}
} else {
return null;
}
}
}
